import React from "react"
import AboutGallery from "../../components/sutea/AboutGallery"
import AboutInfo from "../../components/sutea/AboutInfo"
import AboutMap from "../../components/sutea/AboutMap"
import AboutStaff from "../../components/sutea/AboutStaff"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/sutea/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const about = () => (
  <Layout>
    <SEO title={PAGE.title.about} siteTitle="すてあ" />
    <HeadingL title={PAGE.title.about} target="sutea" />
    <AboutInfo />
    <AboutMap />
    <AboutStaff />
    <AboutGallery />
  </Layout>
)

export default about
